import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from 'src/app/services/language.service';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-marketing',
    template: '<router-outlet></router-outlet>',
    standalone: true,
    imports: [RouterOutlet]
})
export class MarketingComponent {

    constructor(
        public translate: TranslateService,
        private languageService: LanguageService
      ) {
        translate.addLangs(['en-EN', 'fr-FR', 'de-DE', 'es-ES', 'it-IT', 'nl-NL']);
        translate.setDefaultLang(
          languageService.get() ? languageService.get() : 'en-EN'
        );
      }

}
